import React from "react";

const COLORS = {
  // status: green / amber / red / cyan / neutral
  "New": "amber", "Needs Review": "amber", "Qualified": "cyan",
  "Documents Downloaded": "cyan", "Questions Needed": "amber",
  "Bid/No-Bid Pending": "amber", "Preparing Bid": "cyan",
  "Submitted": "cyan", "Award Watch": "amber", "Won": "green",
  "Lost": "red", "No-Bid": "red", "Archived": "neutral",
  "New Candidate": "amber", "Approved to Import": "green",
  "Rejected": "red", "Imported": "green", "Archive": "neutral",
  "Possible Duplicate": "amber", "Duplicate": "red", "Unique": "green", "Unclear": "neutral",
  "Open": "amber", "In Progress": "cyan", "Waiting": "amber",
  "Completed": "green", "Blocked": "red",
  "Critical": "red", "High": "amber", "Medium": "cyan", "Low": "neutral",
  "Active": "green", "Prospect": "cyan", "Preferred": "green",
  "On Hold": "amber", "Do Not Use": "red",
  "Yes": "green", "No": "red", "Likely": "green", "Likely No": "amber",
  "Strong": "green", "Weak": "red", "No Match": "red", "Exact Match": "green",
  "Likely Match": "cyan", "Needs Clarification": "amber", "Mismatch": "red",
  "Delayed": "red", "Shipped": "cyan", "Received": "green", "Approved": "green",
  "Failed": "red", "Passed": "green", "Pending": "amber", "Requested": "amber",
  "Not Started": "neutral", "In Production": "cyan", "Ready to Ship": "cyan",
  "Delivered": "green", "Bid": "green", "Undecided": "amber",
  "Decision Needed": "amber", "Hold / Awaiting Info": "cyan",
  "Strong Fit": "green", "Review": "amber", "Weak Fit": "neutral", "Reject": "red",
  // V2 deterministic confidence + verification labels
  "High Confidence": "green", "Medium Confidence": "cyan", "Low Confidence": "amber",
  "Rejected / Noise": "red", "Verified": "green", "Needs More Info": "amber",
  "Historical Example": "neutral", "Historical Example / Not Active": "neutral",
  "Hold": "amber", "Unverified": "neutral", "Manual Download": "amber",
};

const SWATCH = {
  amber:   { bg: "rgba(255,179,0,0.10)",  bd: "#FFB300", fg: "#FFB300" },
  green:   { bg: "rgba(0,230,118,0.10)",  bd: "#00E676", fg: "#00E676" },
  red:     { bg: "rgba(255,59,48,0.10)",  bd: "#FF3B30", fg: "#FF3B30" },
  cyan:    { bg: "rgba(0,229,255,0.10)",  bd: "#00E5FF", fg: "#00E5FF" },
  neutral: { bg: "rgba(255,255,255,0.04)", bd: "#52525B", fg: "#A1A1AA" },
};

export default function StatusPill({ value, size = "sm" }) {
  if (value === null || value === undefined || value === "") return <span className="text-zinc-600">—</span>;
  const tone = COLORS[value] || "neutral";
  const c = SWATCH[tone];
  const padding = size === "sm" ? "px-2 py-[2px]" : "px-3 py-1";
  return (
    <span
      className={`inline-flex items-center ${padding} rounded-none border font-mono-data text-[10px] tracking-wider uppercase`}
      style={{ background: c.bg, borderColor: c.bd, color: c.fg }}
    >
      {String(value)}
    </span>
  );
}
